import { useQuery } from '@tanstack/react-query';
import { WithQueryStatus } from '../../../types/withQueryStatus';
import { IContractor } from '@clickersphere/core/entities/IContractor';
import ContractorService from '@clickersphere/core/services/ContractorService';
import { useBuildQueryKey } from '../useBuildQueryKey';
import { useUserMe } from '../user/useUserMe';

export const CONTRACTORS_QUERY_KEY = 'contractors';

export type ContractorQueryData = WithQueryStatus<IContractor>;

export function useContractors() {
  const { selectedTenantId } = useUserMe();
  const { buildQueryKey } = useBuildQueryKey();

  const {
    data: contractors,
    isSuccess: isContractorsSuccess,
    isFetching: isContractorsFetching,
    isLoading: isContractorsLoading,
  } = useQuery({
    staleTime: 1000 * 60 * 5,
    enabled: !!selectedTenantId,
    queryKey: buildQueryKey(CONTRACTORS_QUERY_KEY),
    queryFn: async () => {
      const result = await ContractorService.getAll();
      return result as ContractorQueryData[];
    },
    select: (data) => [...data].sort((a, b) => a.name.localeCompare(b.name)),
  });

  return {
    contractors: contractors ?? [],
    isContractorsSuccess,
    isContractorsFetching,
    isContractorsLoading,
  };
}
